import React, {useMemo} from "react";
import { connect } from "react-redux";
import {injectIntl} from "react-intl";
import PropTypes from "prop-types";

import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

import {setSelectedFilters} from "../../../../actions/actionFunctions";
import {getFeatureGroupName} from "../../../../misc/helpers";
import {toggleFilterArrayValue} from "../../../visComponents/navigation/newFilters/filtersBody";


const ShopCategoryAsideProductGroupsFilter = (props) => {

  const {shopNavItems, intl, fabricatorData, selectedFilters, setSelectedFilters} = props;

  const multipleGroupsFilters = useMemo(() => {
    return shopNavItems.reduce((total, navItem) => {
      if (!navItem || !navItem.part || !navItem.part.partId || total[navItem.part.partId]) {
        return total;
      }
      total[navItem.part.partId] = navItem.part.getParent();
      return total
    }, {})
  }, [shopNavItems]);

  const multipleKeys = Object.keys(multipleGroupsFilters);

  if (!multipleKeys.length) {
    return null
  }

  const checkboxClick = (partId) => {
    setSelectedFilters(toggleFilterArrayValue([...selectedFilters], {
      filterGroupId: "partId",
      filterId: partId,
    }));
  }

  const filterByGroupNames = selectedFilters.filter(filter => filter.filterGroupId === "partId");

  return (
    <li className="lk-info__list-item">
      <div className="grohe-filters__list-item-header">
        <span className="lk-info__header-title">
          Product Groups
          {filterByGroupNames.length ? ` (${filterByGroupNames.length})` : null}
        </span>
      </div>
      <div className="lk-info__content">
        {multipleKeys.map((partId) => {
          const featureGroupName = getFeatureGroupName(multipleGroupsFilters[partId], intl, fabricatorData);
          const checked = filterByGroupNames.some((filter) => filter.filterId === partId);
          return (
            <div key={partId}
                 className="g-filters">
              <FormControlLabel
                label={featureGroupName}
                className="g-filters__item"
                control={<Checkbox checked={checked}
                                   name={partId}
                                   className="g-filters__item-checkbox"
                                   onChange={() => checkboxClick(partId)}/>}
              />
            </div>
          )
        })}
      </div>
    </li>
  )
};

ShopCategoryAsideProductGroupsFilter.propTypes = {
  shopNavItems: PropTypes.array.isRequired,
}

const mapStateToProps = (store) => {
  const {selectedFilters} = store.filterState;
  return {
    selectedFilters,
    fabricatorData: store.fabricatorState,
  };
};

const mapDispatchToProps = {
  setSelectedFilters,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(ShopCategoryAsideProductGroupsFilter)
)
